import * as React from "react";
import { useEffect, useState } from "react";
import { useCurrentUser } from "state/auth";
import FullPageSpinner from "components/common/FullPageSpinner";

const RememberLogin: React.FC = ({ children }) => {
  const [loaded, setLoaded] = useState(false);
  const retrieveCurrentUser = useCurrentUser();

  useEffect(() => {
    if (loaded) return;
    setLoaded(true);
    const attemptLoadUser = async () => {
      await retrieveCurrentUser();
    };
    attemptLoadUser();
  }, [loaded, retrieveCurrentUser]);

  if (!loaded) {
    return <FullPageSpinner />;
  }

  return <>{children}</>;
};

export default RememberLogin;
